module.exports = __webpack_public_path__ + "img/info_outline.ae9251dd.svg";